"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var IbeLinkApi = /** @class */ (function () {
    function IbeLinkApi() {
        // scoped state
        this.state = {
            link: null
        };
        this.getters = {
            getLink: function (state) { return state.link; }
        };
        this.actions = {
            createLink: function (_a) {
                var commit = _a.commit, getters = _a.getters;
                var cruise = getters['generalCruise'];
                var priceModel = getters['generalCruise'].priceModel;
                var cabinCategory = getters['cabins/selectedCabinCategoryCode'];
                var adults = getters['persons/all'].adults;
                var juveniles = getters['persons/all'].juveniles;
                var children = getters['persons/all'].children;
                // if (state.affiliate.id) data.affiliate = state.affiliate
                var data = [
                    encodeURIComponent('[cruiseId]') + "=" + cruise.id,
                    encodeURIComponent('[priceModel]') + "=" + priceModel,
                    encodeURIComponent('[cabinCategory]') + "=" + cabinCategory,
                    encodeURIComponent('[paxConfig][A]') + "=" + adults,
                    encodeURIComponent('[paxConfig][J]') + "=" + juveniles,
                    encodeURIComponent('[paxConfig][C]') + "=" + children
                ].map(function (str) {
                    return "tx_aidaibe_booking" + str;
                }).join('&');
                var ibeLink = "https://www.aida.de/kreuzfahrt/angebote-buchen/ibe.20389.html?" + data;
                commit('SET_LINK', ibeLink);
            }
        };
        this.mutations = {
            SET_LINK: function (state, data) { state.link = data; }
        };
    }
    return IbeLinkApi;
}());
exports.IbeLinkApi = IbeLinkApi;
//# sourceMappingURL=ibe_link.js.map